import { useParams } from "react-router";
import { DocumentationCard } from "@/services/backend/rlt/work-orders/components/documentation-card";
import { useRltWorkOrderShowQuery } from "@/services/backend/rlt/work-orders/api/work-order-api";
import { isImmutable } from "@/services/backend/documents/lib/document-state";

export function WorkOrderCompletionDocumentationRoute() {
  const { workOrderId, documentationId } = useParams();
  const { data: workOrder } = useRltWorkOrderShowQuery({ id: workOrderId! });
  return (
    <DocumentationCard
      documentationId={documentationId!}
      workOrderId={workOrderId!}
      disabled={workOrder !== undefined && isImmutable(workOrder)}
    />
  );
}
